/*
  Visor de fotos de la ficha de producto (galeria .sb-gal).
  - Tocar una foto la abre a pantalla completa, creciendo desde su lugar.
  - Deslizar cambia de foto; doble toque (o click en compu) acerca 2.5x y se
    recorre con el dedo; otro doble toque regresa.
  - Cierra con la X, tocando el fondo, deslizando hacia abajo o con Esc.
  Al cerrar, la galeria de la ficha queda en la ultima foto vista.
*/
(function () {
  if (window.__sbZoom) return;
  window.__sbZoom = true;

  var ZOOM = 2.5;
  var box, strip, counter, items = [], gal = null, index = 0, openedAt = 0;

  function big(src) {
    return src.replace(/([?&])width=\d+/, '$1width=2000');
  }

  function build() {
    box = document.createElement('div');
    box.className = 'sb-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Fotos del producto');
    box.innerHTML =
      '<div class="sb-zoom__bg"></div>' +
      '<div class="sb-zoom__strip"></div>' +
      '<div class="sb-zoom__bar"><span class="sb-zoom__count"></span>' +
      '<button type="button" class="sb-zoom__close" aria-label="Cerrar">&times;</button></div>' +
      '<p class="sb-zoom__hint">Doble toque para acercar</p>';
    document.body.appendChild(box);
    strip = box.querySelector('.sb-zoom__strip');
    counter = box.querySelector('.sb-zoom__count');

    box.querySelector('.sb-zoom__close').addEventListener('click', close);
    strip.addEventListener('scroll', function () {
      var i = Math.round(strip.scrollLeft / strip.clientWidth);
      if (i !== index) { unzoomAll(); index = i; count(); }
    }, { passive: true });

    /* Tocar fuera de la foto cierra; doble toque sobre la foto acerca */
    var lastTap = 0;
    strip.addEventListener('click', function (e) {
      if (Date.now() - openedAt < 350) return;
      var slide = e.target.closest('.sb-zoom__slide');
      if (!slide) return;
      var onImg = e.target.tagName === 'IMG';
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!onImg && !slide.classList.contains('is-zoomed')) { close(); return; }
      if (fine) { toggleZoom(slide, e); return; }
      var now = Date.now();
      if (now - lastTap < 300) { toggleZoom(slide, e); lastTap = 0; }
      else lastTap = now;
    });

    /* Deslizar hacia abajo para cerrar (solo sin zoom) */
    var y0 = null, x0 = 0, dy = 0;
    strip.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || current().classList.contains('is-zoomed')) { y0 = null; return; }
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0;
    }, { passive: true });
    strip.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = e.touches[0].clientY - y0;
      if (Math.abs(e.touches[0].clientX - x0) > Math.abs(dy)) { dy = 0; return; }
      if (dy > 0) {
        current().querySelector('img').style.transform = 'translateY(' + dy + 'px) scale(' + (1 - Math.min(dy, 300) / 1500) + ')';
        box.querySelector('.sb-zoom__bg').style.opacity = String(1 - Math.min(dy, 300) / 400);
      }
    }, { passive: true });
    strip.addEventListener('touchend', function () {
      if (y0 === null) return;
      y0 = null;
      var img = current().querySelector('img');
      if (dy > 110) { close(); return; }
      img.style.transform = '';
      box.querySelector('.sb-zoom__bg').style.opacity = '';
    });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') go(index + 1);
      if (e.key === 'ArrowLeft') go(index - 1);
    });
  }

  function current() { return strip.children[index]; }
  function count() { counter.textContent = items.length > 1 ? (index + 1) + ' / ' + items.length : ''; }
  function go(i) {
    if (i < 0 || i >= items.length) return;
    strip.scrollTo({ left: i * strip.clientWidth, behavior: 'smooth' });
  }

  function unzoomAll() {
    [].forEach.call(strip.querySelectorAll('.is-zoomed'), function (s) {
      var im = s.querySelector('img');
      s.classList.remove('is-zoomed');
      im.style.width = im.dataset.w + 'px';
      im.style.height = im.dataset.h + 'px';
      s.scrollLeft = 0; s.scrollTop = 0;
    });
    box.classList.remove('has-zoomed');
  }

  function toggleZoom(slide, e) {
    var img = slide.querySelector('img');
    if (slide.classList.contains('is-zoomed')) {
      unzoomAll();
      return;
    }
    /* Acerca hacia el punto tocado */
    var r = img.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
    slide.classList.add('is-zoomed');
    box.classList.add('has-zoomed');
    img.style.width = (img.dataset.w * ZOOM) + 'px';
    img.style.height = 'auto';
    requestAnimationFrame(function () {
      slide.scrollLeft = img.offsetWidth * px - slide.clientWidth / 2;
      slide.scrollTop = img.offsetHeight * py - slide.clientHeight / 2;
    });
  }

  function open(g, i) {
    if (!box) build();
    gal = g;
    items = [].slice.call(g.querySelectorAll('.sb-gal__item img'));
    index = i;
    box.classList.add('is-open');
    strip.innerHTML = '';
    items.forEach(function (im) {
      var s = document.createElement('div');
      s.className = 'sb-zoom__slide';
      var n = document.createElement('img');
      /* Primero la foto que ya cargo la ficha (sale al instante) y cuando
         baja la de alta resolucion se cambia sola. */
      n.src = im.currentSrc || im.src;
      var hi = new Image();
      hi.onload = function () { n.src = hi.src; };
      hi.src = big(n.src);
      n.alt = im.alt || '';
      n.draggable = false;
      var f = fitRect(im, strip.clientWidth || window.innerWidth, strip.clientHeight || window.innerHeight);
      n.style.width = f.width + 'px';
      n.style.height = f.height + 'px';
      n.dataset.w = f.width;
      n.dataset.h = f.height;
      s.appendChild(n);
      strip.appendChild(s);
    });
    count();
    box.classList.toggle('is-single', items.length < 2);
    document.documentElement.classList.add('sb-zoom-lock');
    strip.scrollLeft = index * strip.clientWidth;
    openedAt = Date.now();

    /* La foto crece desde donde estaba en la ficha */
    var from = items[index].getBoundingClientRect();
    var img = current().querySelector('img');
    var to = fitRect(items[index], strip.clientWidth, strip.clientHeight);
    img.style.transition = 'none';
    img.style.transform = 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + (from.width / to.width) + ')';
    img.style.transformOrigin = '0 0';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        box.classList.add('is-in');
        img.style.transition = '';
        img.style.transform = '';
        setTimeout(function () { img.style.transformOrigin = ''; }, 380);
      });
    });
  }

  /* Donde queda la foto a pantalla completa (object-fit: contain) */
  function fitRect(im, W, H) {
    var ratio = (im.naturalWidth || 1) / (im.naturalHeight || 1);
    var w = W, h = W / ratio;
    if (h > H) { h = H; w = H * ratio; }
    return { left: (W - w) / 2, top: (H - h) / 2, width: w, height: h };
  }

  function close() {
    if (!box.classList.contains('is-open')) return;
    unzoomAll();
    box.classList.remove('is-in', 'has-zoomed');
    /* La galeria de la ficha se queda en la ultima foto vista */
    var track = gal && gal.querySelector('[data-sb-gal-track]');
    if (track && track.children[index]) {
      track.scrollTo({ left: track.children[index].offsetLeft - track.offsetLeft, behavior: 'auto' });
    }
    setTimeout(function () {
      box.classList.remove('is-open');
      document.documentElement.classList.remove('sb-zoom-lock');
      strip.innerHTML = '';
      box.querySelector('.sb-zoom__bg').style.opacity = '';
    }, 260);
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.sb-gal .sb-gal__item img');
    if (!img) return;
    var g = img.closest('.sb-gal');
    var list = [].slice.call(g.querySelectorAll('.sb-gal__item img'));
    e.preventDefault();
    open(g, Math.max(0, list.indexOf(img)));
  });
})();
